var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        confirmLoading: _vm.confirmLoading,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["common.creator"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["createBy"],
                        expression: "[ 'createBy']"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["common.createTime"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-date", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["createTime"],
                        expression: "[ 'createTime']"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { "trigger-change": true }
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["common.modifier"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["updateBy", _vm.validatorRules.updateBy],
                        expression: "[ 'updateBy', validatorRules.updateBy]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["common.modifyTime"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-date", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["updateTime", _vm.validatorRules.updateTime],
                        expression: "[ 'updateTime', validatorRules.updateTime]"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { "trigger-change": true }
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["serial.docCat"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["docCat", _vm.validatorRules.docCat],
                        expression: "[ 'docCat', validatorRules.docCat]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["serial.prefix"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["prefix", _vm.validatorRules.prefix],
                        expression: "[ 'prefix', validatorRules.prefix]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["serial.dateFormat"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["dateFormat", _vm.validatorRules.dateFormat],
                        expression: "[ 'dateFormat', validatorRules.dateFormat]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["serial.currentDate"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["currDate", _vm.validatorRules.currDate],
                        expression: "[ 'currDate', validatorRules.currDate]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["serial.dataFormat"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: [
                          "numberFormat",
                          _vm.validatorRules.numberFormat
                        ],
                        expression:
                          "[ 'numberFormat', validatorRules.numberFormat]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["serial.currentData"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["currNo", _vm.validatorRules.currNo],
                        expression: "[ 'currNo', validatorRules.currNo]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["serial.remark"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["remark", _vm.validatorRules.remark],
                        expression: "[ 'remark', validatorRules.remark]"
                      }
                    ]
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.language["serial.activeFlag"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-dict-select-tag", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["activeFlag", _vm.validatorRules.activeFlag],
                        expression: "[ 'activeFlag', validatorRules.activeFlag]"
                      }
                    ],
                    attrs: { dictCode: "active_flag" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }